// extracted by mini-css-extract-plugin
export default {"root":"PlanCardMaxPromoTooltip_root__6qQFS","title":"PlanCardMaxPromoTooltip_title__+Nglk"};